import { EasyForm, EasyHtml, EasyMarkdown, EasyCode } from '@q/easy-render';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Skeleton } from 'antd';
import ScrollView from '@/ui/scroll-view';
import planQuestionStore from './store';
import EE from '@/common/event';
import Countdown from './countdown';
import { useMemo } from 'react';
import chatStoreManager from '@/store/chat/manager';
import './index.scss'

const PlanQuestion = observer(props => {
  const {
    className = '',
    countdownClassName = '',
    planData,
    planStepId,
    planed = false,
    requestPlanParams,
    hideTitle = false,
    scene = 'right',
  } = props;

  const planRef = useRef(null);
  const [disable, setDisable] = useState(planed);
  const [requested, setRequested] = useState(false);
  const [formRes, setFormRes] = useState(null)
  const formResRef = useRef(null)

  const isLeftScene = scene == 'left';
  const chatStore = chatStoreManager.current;
  const messageItem = chatStore.messageMap.get(requestPlanParams.message_id)
  const memoInputs = useMemo(() => {
    return planData?.inputs
  }, [Object.keys(planData?.inputs).length])

  useEffect(() => {
    setDisable(planed);
  }, [planed]);

  useEffect(() => {
    if (memoInputs && !messageItem?.is_history) {
      planQuestionStore
        .handleAction(formResRef.current, 1, requestPlanParams)
        .then(res => {
          if (res.code == 0) {

          }
        });
    }
  }, [memoInputs])
  console.log("disable is", planData)
  return (
    <div
      ref={planRef}
      className={['mcp-tools-plan relative', false ? '' : 'pr-4px', className]}
      data-id={planStepId}
      onClick={event => {
        event.stopPropagation();
      }}
    >
      {(!planData || !planData.form_data?.length) && !disable ? (
        <Skeleton className="px-24px" active />
      ) : (
        <>
          <ScrollView
            className={[
              isLeftScene ? '' : 'max-h-[calc(100vh-400px)] pl-24px pr-20px',
            ]}
          >
            <EasyForm
              disabled={disable}
              formData={planData?.form_data}
              inputsData={planData?.inputs}
              onChange={result => {
                setFormRes(result)
                formResRef.current = result
                console.log('result is', result);
              }}
            />
          </ScrollView>

          <div
            className={[
              'flex pt-12px mcp-mobile-hidden',
              isLeftScene ? '' : 'pl-24px pr-20px',
            ]}
          >
            <div
              onClick={evt => {
                if (disable || requested) return;

                planQuestionStore
                  .handleAction(formRes, 0, requestPlanParams)
                  .then(res => {
                    if (res?.code == 0) {
                      setRequested(true);
                      EE.emit('confirm_countdown_reload');
                    }
                  });
              }}
              className={[
                'flex-1 h-36px rounded-8px vh-center text-14px font-bold text-black border-1px border-black border-opacity-16 mr-12px',
                disable || requested
                  ? 'opacity-30'
                  : 'hover:bg-[rgba(0,0,0,0.03)] cursor-pointer',
              ]}
            >
              跳过
            </div>
            <div
              onClick={evt => {
                if (disable || requested) return;

                planQuestionStore
                  .handleAction(formRes, 0, requestPlanParams)
                  .then(res => {
                    if (res?.code == 0) {
                      setRequested(true);
                      EE.emit('confirm_countdown_reload');
                    }
                  });
              }}
              className={[
                'flex-1 h-36px rounded-8px vh-center text-14px font-bold bg-black',
                disable || requested
                  ? 'bg-opacity-6 text-black text-opacity-50'
                  : 'text-white hover:bg-[#333] cursor-pointer',
              ]}
            >
              确认
            </div>
          </div>

          {(disable || requested) ? null : (
            <Countdown
              planStepId={planStepId}
              disable={disable || requested}
              timeout={
               60
              }
              overrun={evt => {
                planQuestionStore
                  .handleAction(formRes, 0, requestPlanParams)
                  .then(res => {
                    if (res.code == 0) {
                      setRequested(true);
                    }
                  });
              }}
              className={[
                'absolute  bottom-0px transform translate-y-[calc(100%+18px+24px)]',
                isLeftScene ? 'left-[-24px]' : 'left-0px',
                countdownClassName,
              ]}
            />
          )}
        </>
      )}
    </div>
  );
});
export default PlanQuestion;
